<template>
  <div class="ball-chosen">
    <div class="ball-chosen__title">
      {{ title }}
    </div>
    <div v-if="dataChosen.length > 0" class="ball-chosen__content">
      <div
          v-for="(item, index) in dataChosen"
          :key="index"
          class="ball-chosen__content-item"
      >
        <div v-if="item.moreDrawName !== ''" class="ball-chosen__content-item">
          <div class="ball-chosen__item-number ball-chosen__item-custom">{{ item.moreDrawName }}</div>
          <div class="text-chosen">{{ item.shortText }}</div>
        </div>
        <div v-if="item.moreDrawName === ''" class="ball-chosen__content-item">
          <div class="ball-chosen__item-number">{{ item.Main.length }} numbers</div>
          <div v-if="item.Main && item.Main.length > 0" class="ball-chosen__item-numbers">
            <div
                v-for="(number, i) in item.Main"
                :key="i"
                class="number-chosen"
                :class="{bonus: number.isBonus || number.type === 'power' || number.type === 'bonus'}"
            >{{ number.number }}</div>
          </div>
        </div>
        <div class="ball-chosen__item-button">
<!--          <button @click="$emit('handleAddFAV', item)">ADD TO FAV</button>-->
          <div class="item-close">
            <img
                @click="$emit('delete-item', index+1)"
                src="@/assets/images/ticket/remove.png" />
          </div>
        </div>
      </div>
    </div>
    <div class="ball-chosen__market-ball-bottoms">
      <div @click="$router.go(-1)" class="ball-chosen__market-ball-go-back item-common">
        GO BACK
      </div>
      <div @click="$emit('clickAddBetslip')" class="ball-chosen__market-ball-add item-common">
        ADD TO BETSLIP
      </div>
      <div
          @click="$emit('clickViewBetslip')"
          class="ball-chosen__market-ball-view item-common"
      >
        VIEW BETSLIP
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    dataChosen: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style scoped lang="scss" src="@/assets/scss/common/ball/ball-chosen.scss"/>
